"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeSupportedParamType = exports.BasicScryptType = exports.BasicType = exports.VariableType = exports.SortedItem = exports.HashedSet = exports.HashedMap = exports.Library = exports.Struct = exports.OpCodeType = exports.SigHashPreimage = exports.SigHashType = exports.SigHash = exports.Sha256 = exports.Sha1 = exports.PubKeyHash = exports.Ripemd160 = exports.Sig = exports.PubKey = exports.PrivKey = exports.String = exports.Bytes = exports.Bool = exports.Int = exports.ScryptType = exports.SymbolType = void 0;
var internal_1 = require("./internal");
var serializer_1 = require("./serializer");
var SymbolType;
(function (SymbolType) {
    SymbolType["BaseType"] = "BaseType";
    SymbolType["Contract"] = "Contract";
    SymbolType["Library"] = "Library";
    SymbolType["Struct"] = "Struct";
    SymbolType["Unknown"] = "Unknown";
})(SymbolType = exports.SymbolType || (exports.SymbolType = {}));
var ScryptType = /** @class */ (function () {
    function ScryptType() {
        var value = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            value[_i] = arguments[_i];
        }
        try {
            this._value = this.checkValue(value);
            this._literal = this.toLiteral();
            var _a = __read(internal_1.parseLiteral(this._literal), 3), asm = _a[0], _ = _a[1], scrType = _a[2];
            this._type = scrType;
            this._asm = asm;
        }
        catch (error) {
            throw new Error("can't construct " + this.constructor.name + " from <" + value + ">, " + error.message);
        }
    }
    Object.defineProperty(ScryptType.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScryptType.prototype, "finalType", {
        get: function () {
            if (this._typeResolver)
                return this._typeResolver(this.type).finalType;
            return this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScryptType.prototype, "literal", {
        get: function () {
            return this._literal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScryptType.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    ScryptType.prototype.toASM = function () {
        return this._asm;
    };
    ScryptType.prototype.toHex = function () {
        return internal_1.mvc.Script.fromASM(this._asm).toHex();
    };
    ScryptType.prototype.toString = function (format) {
        if (format === 'hex') {
            return this.toHex();
        }
        return this.toLiteral();
    };
    ScryptType.prototype.toJSON = function () {
        return this.toLiteral();
    };
    ScryptType.prototype.toLiteral = function () {
        return '';
    };
    ScryptType.prototype.checkValue = function (value) {
        if (typeof value === 'undefined') {
            throw new Error('constructor argument undefined');
        }
        if (value.length !== 1) {
            throw new Error('constructor argument undefined');
        }
        return value[0];
    };
    ScryptType.prototype.equals = function (obj) {
        return obj.finalType === this.finalType && obj.toASM() === this.toASM();
    };
    ScryptType.prototype.serialize = function () {
        return '';
    };
    ScryptType.prototype.clone = function () {
        return Object.assign(Object.create(this), {
            _value: this.value
        });
    };
    return ScryptType;
}());
exports.ScryptType = ScryptType;
var Int = /** @class */ (function (_super) {
    __extends(Int, _super);
    function Int(intVal) {
        return _super.call(this, intVal) || this;
    }
    Int.prototype.toLiteral = function () {
        return this._value.toString();
    };
    Int.prototype.checkValue = function (value) {
        _super.prototype.checkValue.call(this, value);
        if (!internal_1.isInteger(value[0])) {
            throw new Error('Only supports integers, should use integer number, bigint, hex string or decimal string: ' + value[0]);
        }
        if (typeof value[0] == 'number' && !isNaN(value[0])) {
            if (!Number.isSafeInteger(value[0])) {
                throw new Error("<" + value[0] + "> is not safe integer, should use bigint, hex string or decimal string");
            }
        }
        return value[0];
    };
    Int.prototype.toJSON = function () {
        return this.value;
    };
    Int.prototype.serialize = function () {
        return serializer_1.serializeInt(this.value);
    };
    Int.prototype.toNumber = function () {
        if (typeof this._value === 'number') {
            return this._value;
        }
        else if (typeof this._value === 'bigint') {
            return internal_1.int2Value(this._value.toString());
        }
        return internal_1.int2Value(this.value);
    };
    return Int;
}(ScryptType));
exports.Int = Int;
var Bool = /** @class */ (function (_super) {
    __extends(Bool, _super);
    function Bool(boolVal) {
        return _super.call(this, boolVal) || this;
    }
    Bool.prototype.toLiteral = function () {
        return this._value.toString();
    };
    Bool.prototype.serialize = function () {
        return this.value ? '01' : '00';
    };
    return Bool;
}(ScryptType));
exports.Bool = Bool;
var Bytes = /** @class */ (function (_super) {
    __extends(Bytes, _super);
    function Bytes(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    Bytes.prototype.toLiteral = function () {
        return "b'" + internal_1.getValidatedHexString(this._value.toString()) + "'";
    };
    Bytes.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return Bytes;
}(ScryptType));
exports.Bytes = Bytes;
var String = /** @class */ (function (_super) {
    __extends(String, _super);
    function String(val) {
        return _super.call(this, String.toUtf8Hex(val)) || this;
    }
    String.toUtf8Hex = function (val) {
        var encoder = new TextEncoder();
        var uint8array = encoder.encode(val);
        return internal_1.toHex(Buffer.from(uint8array));
    };
    String.fromUtf8Hex = function (hex) {
        var utf8decoder = new TextDecoder();
        return utf8decoder.decode(Buffer.from(hex, 'hex'));
    };
    String.prototype.toLiteral = function () {
        return "\"" + this.show() + "\"";
    };
    String.prototype.show = function () {
        var hex = this.value;
        return String.fromUtf8Hex(hex);
    };
    return String;
}(Bytes));
exports.String = String;
var PrivKey = /** @class */ (function (_super) {
    __extends(PrivKey, _super);
    function PrivKey(intVal) {
        return _super.call(this, intVal) || this;
    }
    PrivKey.prototype.toLiteral = function () {
        if (typeof this._value === 'string') {
            return "PrivKey(" + this._value + ")";
        }
        else {
            var v = this._value;
            return "PrivKey(0x" + internal_1.intValue2hex(v) + ")";
        }
    };
    PrivKey.prototype.toJSON = function () {
        return this.toLiteral();
    };
    PrivKey.prototype.serialize = function () {
        return serializer_1.serializeInt(this.value);
    };
    return PrivKey;
}(Int));
exports.PrivKey = PrivKey;
var PubKey = /** @class */ (function (_super) {
    __extends(PubKey, _super);
    function PubKey(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    PubKey.prototype.toLiteral = function () {
        return "PubKey(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    PubKey.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return PubKey;
}(ScryptType));
exports.PubKey = PubKey;
var Sig = /** @class */ (function (_super) {
    __extends(Sig, _super);
    function Sig(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    Sig.prototype.toLiteral = function () {
        return "Sig(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    Sig.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return Sig;
}(ScryptType));
exports.Sig = Sig;
var Ripemd160 = /** @class */ (function (_super) {
    __extends(Ripemd160, _super);
    function Ripemd160(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    Ripemd160.prototype.toLiteral = function () {
        return "Ripemd160(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    Ripemd160.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return Ripemd160;
}(ScryptType));
exports.Ripemd160 = Ripemd160;
var PubKeyHash = /** @class */ (function (_super) {
    __extends(PubKeyHash, _super);
    function PubKeyHash() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PubKeyHash;
}(Ripemd160));
exports.PubKeyHash = PubKeyHash;
var Sha1 = /** @class */ (function (_super) {
    __extends(Sha1, _super);
    function Sha1(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    Sha1.prototype.toLiteral = function () {
        return "Sha1(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    Sha1.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return Sha1;
}(ScryptType));
exports.Sha1 = Sha1;
var Sha256 = /** @class */ (function (_super) {
    __extends(Sha256, _super);
    function Sha256(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    Sha256.prototype.toLiteral = function () {
        return "Sha256(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    Sha256.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return Sha256;
}(ScryptType));
exports.Sha256 = Sha256;
var SigHash;
(function (SigHash) {
    SigHash[SigHash["ALL"] = 1] = "ALL";
    SigHash[SigHash["NONE"] = 2] = "NONE";
    SigHash[SigHash["SINGLE"] = 3] = "SINGLE";
    SigHash[SigHash["FORKID"] = 64] = "FORKID";
    SigHash[SigHash["ANYONECANPAY"] = 128] = "ANYONECANPAY";
    SigHash[SigHash["ALL_FORKID"] = 65] = "ALL_FORKID";
    SigHash[SigHash["SINGLE_FORKID"] = 67] = "SINGLE_FORKID";
    SigHash[SigHash["NONE_FORKID"] = 66] = "NONE_FORKID";
    SigHash[SigHash["ANYONECANPAY_ALL_FORKID"] = 193] = "ANYONECANPAY_ALL_FORKID";
    SigHash[SigHash["ANYONECANPAY_SINGLE_FORKID"] = 195] = "ANYONECANPAY_SINGLE_FORKID";
    SigHash[SigHash["ANYONECANPAY_NONE_FORKID"] = 194] = "ANYONECANPAY_NONE_FORKID";
})(SigHash = exports.SigHash || (exports.SigHash = {}));
var SigHashType = /** @class */ (function (_super) {
    __extends(SigHashType, _super);
    function SigHashType(intVal) {
        return _super.call(this, intVal) || this;
    }
    SigHashType.prototype.toLiteral = function () {
        var hexStr = this._value.toString(16);
        if (hexStr.length % 2) {
            hexStr = '0' + hexStr;
        }
        return "SigHashType(b'" + hexStr + "')";
    };
    SigHashType.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    SigHashType.prototype.toString = function () {
        var types = [];
        var value = this._value;
        if ((value & SigHash.ANYONECANPAY) === SigHash.ANYONECANPAY) {
            types.push('SigHash.ANYONECANPAY');
            value = value - SigHash.ANYONECANPAY;
        }
        if ((value & SigHash.SINGLE) === SigHash.SINGLE) {
            types.push('SigHash.SINGLE');
            value = value - SigHash.SINGLE;
        }
        if ((value & SigHash.NONE) === SigHash.NONE) {
            types.push('SigHash.NONE');
            value = value - SigHash.NONE;
        }
        if ((value & SigHash.ALL) === SigHash.ALL) {
            types.push('SigHash.ALL');
            value = value - SigHash.ALL;
        }
        if ((value & SigHash.FORKID) === SigHash.FORKID) {
            types.push('SigHash.FORKID');
            value = value - SigHash.FORKID;
        }
        if (value === 0) {
            return types.join(' | ');
        }
        throw new Error("unknown sighash type value: " + this._value);
    };
    return SigHashType;
}(ScryptType));
exports.SigHashType = SigHashType;
var SigHashPreimage = /** @class */ (function (_super) {
    __extends(SigHashPreimage, _super);
    function SigHashPreimage(bytesVal) {
        var _this = _super.call(this, bytesVal) || this;
        _this._buf = Buffer.from(bytesVal, 'hex');
        return _this;
    }
    SigHashPreimage.prototype.getReader = function (buf) {
        return new internal_1.mvc.encoding.BufferReader(buf);
    };
    Object.defineProperty(SigHashPreimage.prototype, "nVersion", {
        // nVersion of the transaction
        get: function () {
            return this.getReader(this._buf.slice(0, 4)).readUInt32LE();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "hashPrevouts", {
        // hashPrevouts
        get: function () {
            return this._buf.slice(4, 4 + 32).toString('hex');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "hashSequence", {
        // hashSequence
        get: function () {
            return this._buf.slice(36, 36 + 32).toString('hex');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "outpoint", {
        // outpoint
        get: function () {
            var buf = this._buf.slice(68, 68 + 32 + 4);
            var hex = buf.toString('hex');
            var index = this.getReader(buf.slice(32, 32 + 4)).readUInt32LE();
            var hash = Buffer.from(buf.slice(0, 32)).reverse().toString('hex');
            return {
                hash: hash,
                index: index,
                hex: hex
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "scriptCode", {
        // scriptCode of the input
        get: function () {
            return this.getReader(this._buf.slice(104, this._buf.length - 52)).readVarLengthBuffer().toString('hex');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "amount", {
        // value of the output spent by this input
        get: function () {
            return this.getReader(this._buf.slice(this._buf.length - 44 - 8, this._buf.length - 44)).readUInt32LE();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "nSequence", {
        // nSequence of the input
        get: function () {
            return this.getReader(this._buf.slice(this._buf.length - 40 - 4, this._buf.length - 40)).readUInt32LE();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "hashOutputs", {
        // hashOutputs
        get: function () {
            return this._buf.slice(this._buf.length - 8 - 32, this._buf.length - 8).toString('hex');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "nLocktime", {
        // nLocktime of the transaction
        get: function () {
            return this.getReader(this._buf.slice(this._buf.length - 4 - 4, this._buf.length - 4)).readUInt32LE();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SigHashPreimage.prototype, "sighashType", {
        // sighash type of the signature
        get: function () {
            return this.getReader(this._buf.slice(this._buf.length - 4, this._buf.length)).readUInt32LE();
        },
        enumerable: false,
        configurable: true
    });
    SigHashPreimage.prototype.toString = function (format) {
        if (format === void 0) { format = 'hex'; }
        return this._buf.toString(format);
    };
    SigHashPreimage.prototype.toLiteral = function () {
        return "SigHashPreimage(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    SigHashPreimage.prototype.toJSONObject = function () {
        return {
            nVersion: this.nVersion,
            hashPrevouts: this.hashPrevouts,
            hashSequence: this.hashSequence,
            outpoint: this.outpoint,
            scriptCode: this.scriptCode,
            amount: this.amount,
            nSequence: this.nSequence,
            hashOutputs: this.hashOutputs,
            nLocktime: this.nLocktime,
            sighashType: new SigHashType(this.sighashType).toString()
        };
    };
    SigHashPreimage.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return SigHashPreimage;
}(ScryptType));
exports.SigHashPreimage = SigHashPreimage;
var OpCodeType = /** @class */ (function (_super) {
    __extends(OpCodeType, _super);
    function OpCodeType(bytesVal) {
        return _super.call(this, bytesVal) || this;
    }
    OpCodeType.prototype.toLiteral = function () {
        return "OpCodeType(b'" + internal_1.getValidatedHexString(this._value.toString()) + "')";
    };
    OpCodeType.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    return OpCodeType;
}(ScryptType));
exports.OpCodeType = OpCodeType;
var Struct = /** @class */ (function (_super) {
    __extends(Struct, _super);
    function Struct(o) {
        var _this = _super.call(this, o) || this;
        _this.sorted = false;
        _this.inferredTypes = {};
        return _this;
    }
    Struct.setStructAst = function (self, structAst) {
        Object.getPrototypeOf(self).constructor.structAst = structAst;
    };
    Struct.getStructAst = function (self) {
        return Object.getPrototypeOf(self).constructor.structAst;
    };
    Struct.prototype.flatten = function (varName) {
        return internal_1.flatternStruct(this, varName);
    };
    Struct.prototype.toHex = function () {
        if (!this.sorted) {
            throw 'unbinded Struct can\'t call toHex';
        }
        return internal_1.flatternStruct(this, '').map(function (v) {
            return v.value.toHex();
        }).join('');
    };
    Struct.prototype.init = function () {
        var _this = this;
        internal_1.checkStruct(Struct.getStructAst(this), this);
        this.inferrTypesByValue();
        var structAst = this.getStructAst();
        structAst.params.forEach(function (p) {
            var member = _this.memberByKey(p.name);
            internal_1.checkStructField(structAst, p, member, _this._typeResolver);
        });
        var ordered = {};
        var unordered = this.value;
        Object.keys(this.value).sort(function (a, b) {
            return (structAst.params.findIndex(function (e) {
                return e.name === a;
            }) - structAst.params.findIndex(function (e) {
                return e.name === b;
            }));
        }).forEach(function (key) {
            ordered[key] = unordered[key];
        });
        this.sorted = true;
        this._type = structAst.name;
        this._value = ordered;
    };
    Struct.prototype.bind = function () {
        var _this = this;
        this.init();
        var structAst = this.getStructAst();
        structAst.params.forEach(function (p) {
            Object.defineProperty(_this, p.name, {
                get: function () {
                    return this.memberByKey(p.name);
                },
                set: function (value) {
                    internal_1.checkStructField(structAst, p, value, this._typeResolver);
                    this._value[p.name] = value;
                }
            });
        });
    };
    Struct.prototype.getStructAst = function () {
        var _this = this;
        var structAst = Struct.getStructAst(this);
        return {
            name: structAst.name,
            params: structAst.params.map(function (p) { return ({
                name: p.name,
                type: internal_1.resolveGenericType(_this.inferredTypes, p.type)
            }); }),
            genericTypes: (structAst.genericTypes || []).map(function (t) { return t; })
        };
    };
    Struct.prototype.inferrTypesByValue = function () {
        var _this = this;
        var value = this.value;
        var structAst = this.getStructAst();
        structAst.params.forEach(function (p) {
            var _a;
            var argType = internal_1.inferrType(value[p.name]);
            if (structAst.genericTypes.includes(p.type)) {
                if (_this.inferredTypes[p.type]) {
                    if (_this.inferredTypes[p.type] != argType) {
                        throw new Error("The type of " + structAst.name + " is wrong, expected " + internal_1.structSign(structAst) + " but got " + JSON.stringify(value));
                    }
                }
                else {
                    Object.assign(_this.inferredTypes, (_a = {},
                        _a[p.type] = argType,
                        _a));
                }
            }
            else if (internal_1.isGenericType(p.type)) {
                if (structAst.genericTypes.length > 0) {
                    if (!internal_1.isGenericType(argType)) {
                        throw new Error("The type of " + structAst.name + " is wrong, expected " + internal_1.structSign(structAst) + " but got " + JSON.stringify(value));
                    }
                    var _b = __read(internal_1.parseGenericType(argType), 2), _ = _b[0], argGenericTypes_1 = _b[1];
                    var _c = __read(internal_1.parseGenericType(p.type), 2), __ = _c[0], paramGenericTypes = _c[1];
                    paramGenericTypes.forEach(function (t, index) {
                        var _a;
                        if (_this.inferredTypes[t]) {
                            if (_this.inferredTypes[t] != argGenericTypes_1[index]) {
                                throw new Error("The type of " + structAst.name + " is wrong, expected " + internal_1.structSign(structAst) + " but got " + JSON.stringify(value));
                            }
                        }
                        else {
                            Object.assign(_this.inferredTypes, (_a = {},
                                _a[t] = argGenericTypes_1[index],
                                _a));
                        }
                    });
                }
            }
        });
    };
    Struct.prototype.inferrTypesByAssign = function (assignType) {
        var _this = this;
        if (!Struct.hasGeneric(this)) {
            return false;
        }
        var _a = __read(internal_1.parseGenericType(assignType), 2), struct = _a[0], genericTypes = _a[1];
        var structAst = this.getStructAst();
        if (structAst.name !== struct)
            return false;
        if (structAst.genericTypes.length !== genericTypes.length)
            return false;
        var succces = true;
        structAst.genericTypes.forEach(function (t, index) {
            var _a;
            var realT = genericTypes[index];
            if (_this.inferredTypes[t]) {
                if (_this.inferredTypes[t] != realT) {
                    succces = false;
                }
            }
            else {
                Object.assign(_this.inferredTypes, (_a = {},
                    _a[t] = realT,
                    _a));
            }
        });
        return succces;
    };
    Struct.prototype.toASM = function () {
        if (!this.sorted) {
            throw 'unbinded Struct can\'t call toASM';
        }
        this._asm = internal_1.flatternStruct(this, '').map(function (v) {
            return v.value.toASM();
        }).join(' ');
        return this._asm;
    };
    /**
     * @deprecated use  flatternStruct, see toASM
     */
    Struct.prototype.toArray = function () {
        if (!this.sorted) {
            throw 'unbinded Struct can\'t call toArray';
        }
        return Object.values(this.value).map(function (v) { return internal_1.toScryptType(v); });
    };
    Struct.prototype.memberByIndex = function (index) {
        if (!this.sorted) {
            throw 'unbinded Struct can\'t call memberByIndex';
        }
        var v = this.value;
        return Object.keys(v)[index];
    };
    /**
    * @deprecated use  getMemberFinalType
    */
    Struct.prototype.getMemberType = function (key) {
        var v = this.value;
        return internal_1.toScryptType(v[key]).type;
    };
    /**
     * Get the real member type of the structure
     */
    Struct.prototype.getMemberFinalType = function (key) {
        var member = this.memberByKey(key);
        return internal_1.typeOfArg(member);
    };
    /**
     * Get the member type declared by the structure by structAst
     */
    Struct.prototype.getMemberAstFinalType = function (key) {
        var structAst = this.getStructAst();
        var paramEntity = structAst.params.find(function (p) {
            return p.name === key;
        });
        if (!paramEntity) {
            throw new Error(key + " is member of struct " + structAst.name);
        }
        return this._typeResolver(paramEntity.type).finalType;
    };
    Struct.prototype.getMembers = function () {
        var v = this.value;
        return Object.keys(v);
    };
    Struct.prototype.memberByKey = function (key) {
        var v = this.value;
        var member = v[key];
        if (Array.isArray(member)) {
            return member;
        }
        return typeof member !== 'undefined' ? internal_1.toScryptType(member) : undefined;
    };
    Struct.prototype.clone = function () {
        var _this = this;
        return Object.assign(Object.create(this), {
            _value: Object.keys(this.value).reduce(function (pre, current) {
                var _a, _b;
                var value = _this.value[current];
                if (Array.isArray(value)) {
                    Object.assign(pre, (_a = {},
                        _a[current] = internal_1.cloneArray(value),
                        _a));
                }
                else {
                    Object.assign(pre, (_b = {},
                        _b[current] = internal_1.toScryptType(value).clone(),
                        _b));
                }
                return pre;
            }, {})
        });
    };
    Struct.prototype.toLiteral = function () {
        var v = this.value;
        var l = Object.keys(this.value).map(function (key) {
            if (Array.isArray(v[key])) {
                return internal_1.arrayToLiteral(v[key]);
            }
            else {
                return internal_1.toScryptType(v[key]).toLiteral();
            }
        }).join(',');
        return "{" + l + "}";
    };
    Struct.prototype.toJSON = function () {
        var v = this.value;
        return Array.from(Object.keys(v)).reduce(function (obj, key) {
            var _a, _b, _c, _d;
            if (v[key] instanceof ScryptType) {
                if (Struct.isStruct(v[key])) {
                    return Object.assign(obj, (_a = {}, _a[key] = v[key].toJSON(), _a));
                }
                else if (Array.isArray(v[key])) {
                    return Object.assign(obj, (_b = {}, _b[key] = internal_1.arrayToJson(v[key]), _b));
                }
                else {
                    return Object.assign(obj, (_c = {}, _c[key] = v[key].toLiteral(), _c));
                }
            }
            else {
                return Object.assign(obj, (_d = {}, _d[key] = v[key], _d));
            }
        }, {});
    };
    Struct.isStruct = function (arg) {
        return arg instanceof Struct;
    };
    Struct.prototype.serialize = function () {
        return serializer_1.serialize(this.value);
    };
    Struct.hasGeneric = function (self) {
        var ast = Struct.getStructAst(self);
        return (ast.genericTypes || []).length > 0;
    };
    Object.defineProperty(Struct.prototype, "finalType", {
        get: function () {
            var _this = this;
            if (this._typeResolver) {
                if (Struct.hasGeneric(this)) {
                    var structAst = this.getStructAst();
                    var type = internal_1.toGenericType(this.type, structAst.genericTypes.map(function (t) { return (_this.inferredTypes[t] || t); }));
                    return this._typeResolver(type).finalType;
                }
                else {
                    return this._typeResolver(this.type).finalType;
                }
            }
            return this.type;
        },
        enumerable: false,
        configurable: true
    });
    return Struct;
}(ScryptType));
exports.Struct = Struct;
var Library = /** @class */ (function (_super) {
    __extends(Library, _super);
    function Library() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        // store the value of properties
        _this.properties = {};
        _this.inferredTypes = {};
        var libraryAst = _this.getLibraryAst();
        if (internal_1.canAssignProperty(libraryAst)) {
            args.forEach(function (arg, index) {
                var _a;
                Object.assign(_this.properties, (_a = {},
                    _a[libraryAst.params[index].name] = arg,
                    _a));
            });
        }
        return _this;
    }
    Library.setLibraryAst = function (self, libraryAst) {
        Object.getPrototypeOf(self).constructor.libraryAst = libraryAst;
    };
    Library.getLibraryAst = function (self) {
        return Object.getPrototypeOf(self).constructor.libraryAst;
    };
    Library.prototype.getCtorArgs = function () {
        var args = this.value;
        return internal_1.arrayToScryptType(args);
    };
    Library.prototype.cloneProperties = function () {
        var _this = this;
        return Object.keys(this.properties).reduce(function (pre, current) {
            var _a, _b;
            var value = _this.properties[current];
            if (Array.isArray(value)) {
                Object.assign(pre, (_a = {},
                    _a[current] = internal_1.cloneArray(value),
                    _a));
            }
            else {
                Object.assign(pre, (_b = {},
                    _b[current] = internal_1.toScryptType(value).clone(),
                    _b));
            }
            return pre;
        }, {});
    };
    Library.prototype.clone = function () {
        return Object.assign(Object.create(this), {
            _value: internal_1.cloneArray(this.getCtorArgs()),
            properties: this.cloneProperties()
        });
    };
    Library.prototype.getProperty = function (property) {
        var p = this.properties[property];
        if (typeof p === 'undefined') {
            throw new Error("Property " + property + " not found, the properties of the current library are: " + JSON.stringify(this.properties));
        }
        return internal_1.toScryptType(p);
    };
    Library.prototype.getProperties = function () {
        return this.properties;
    };
    Library.prototype.getLibraryAst = function () {
        var _this = this;
        var libraryAst = Library.getLibraryAst(this);
        return {
            name: libraryAst.name,
            params: libraryAst.params.map(function (p) { return ({
                name: p.name,
                type: internal_1.resolveGenericType(_this.inferredTypes, p.type)
            }); }),
            properties: libraryAst.properties.map(function (p) { return ({
                name: p.name,
                type: internal_1.resolveGenericType(_this.inferredTypes, p.type)
            }); }),
            genericTypes: libraryAst.genericTypes.map(function (t) { return t; })
        };
    };
    Library.prototype.flatten = function (varName) {
        return internal_1.flatternLibrary(this, varName);
    };
    Library.prototype.checkValue = function (args) {
        var libraryAst = Library.getLibraryAst(this);
        if (libraryAst.params.length !== args.length) {
            throw new Error("The type of " + libraryAst.name + " is wrong, expected " + internal_1.librarySign(libraryAst) + " but got " + JSON.stringify(args));
        }
        return args;
    };
    Library.prototype.inferrTypesByValue = function () {
        var _this = this;
        var args = this.value;
        var libraryAst = this.getLibraryAst();
        libraryAst.params.forEach(function (p, index) {
            var _a;
            var argType = internal_1.inferrType(args[index]);
            if (libraryAst.genericTypes.includes(p.type)) {
                if (_this.inferredTypes[p.type]) {
                    if (_this.inferredTypes[p.type] != argType) {
                        throw new Error("The type of " + libraryAst.name + " is wrong, expected " + internal_1.librarySign(libraryAst) + " but got " + JSON.stringify(args));
                    }
                }
                else {
                    Object.assign(_this.inferredTypes, (_a = {},
                        _a[p.type] = argType,
                        _a));
                }
            }
            else if (internal_1.isGenericType(p.type)) {
                if (libraryAst.genericTypes.length > 0) {
                    if (!internal_1.isGenericType(argType)) {
                        throw new Error("The type of " + libraryAst.name + " is wrong, expected " + internal_1.librarySign(libraryAst) + " but got " + JSON.stringify(args));
                    }
                    var _b = __read(internal_1.parseGenericType(argType), 2), _ = _b[0], argGenericTypes_2 = _b[1];
                    var _c = __read(internal_1.parseGenericType(p.type), 2), __ = _c[0], paramGenericTypes = _c[1];
                    paramGenericTypes.forEach(function (t, index) {
                        var _a;
                        if (_this.inferredTypes[t]) {
                            if (_this.inferredTypes[t] != argGenericTypes_2[index]) {
                                throw new Error("The type of " + libraryAst.name + " is wrong, expected " + internal_1.librarySign(libraryAst) + " but got " + JSON.stringify(args));
                            }
                        }
                        else {
                            Object.assign(_this.inferredTypes, (_a = {},
                                _a[t] = argGenericTypes_2[index],
                                _a));
                        }
                    });
                }
            }
        });
    };
    Library.prototype.inferrTypesByAssign = function (assignType) {
        var _this = this;
        if (!Library.hasGeneric(this)) {
            return false;
        }
        var _a = __read(internal_1.parseGenericType(assignType), 2), library = _a[0], genericTypes = _a[1];
        var libraryAst = this.getLibraryAst();
        if (libraryAst.name !== library)
            return false;
        if (libraryAst.genericTypes.length !== genericTypes.length)
            return false;
        var succces = true;
        libraryAst.genericTypes.forEach(function (t, index) {
            var _a;
            var realT = genericTypes[index];
            if (_this.inferredTypes[t]) {
                if (_this.inferredTypes[t] != realT) {
                    succces = false;
                }
            }
            else {
                Object.assign(_this.inferredTypes, (_a = {},
                    _a[t] = realT,
                    _a));
            }
        });
        return succces;
    };
    Library.hasGeneric = function (self) {
        var ast = Library.getLibraryAst(self);
        return (ast.genericTypes || []).length > 0;
    };
    Library.prototype.attach = function () {
        var _this = this;
        var libraryAst = this.getLibraryAst();
        this._type = libraryAst.name;
        var args = this.value;
        //check value type
        libraryAst.params.forEach(function (param, index) {
            var error = internal_1.checkSupportedParamType(args[index], param, _this._typeResolver);
            if (error) {
                throw new Error("The type of " + libraryAst.name + " is wrong, expected " + internal_1.librarySign(libraryAst) + " but got " + JSON.stringify(args));
            }
        });
        libraryAst.properties.forEach(function (p) {
            Object.defineProperty(_this, p.name, {
                get: function () {
                    return this.properties[p.name];
                },
                set: function (value) {
                    this.properties[p.name] = value;
                }
            });
        });
    };
    Library.isLibrary = function (arg) {
        return arg instanceof Library;
    };
    Library.prototype.bind = function () {
        this.inferrTypesByValue();
        this.attach();
    };
    Library.prototype.setProperties = function (properties) {
        this.properties = Object.assign(this.properties, properties);
        return this;
    };
    Library.prototype.toJSON = function () {
        return Array.from(Object.values(this.value)).map(function (v) {
            if (Array.isArray(v)) {
                return internal_1.arrayToJson(v);
            }
            else {
                return internal_1.toScryptType(v).toJSON();
            }
        });
    };
    Library.prototype.toLiteral = function () {
        return internal_1.arrayToLiteral(this.value);
    };
    Object.defineProperty(Library.prototype, "finalType", {
        get: function () {
            var _this = this;
            if (this._typeResolver) {
                if (Library.hasGeneric(this)) {
                    var libraryAst = this.getLibraryAst();
                    var type = internal_1.toGenericType(this.type, libraryAst.genericTypes.map(function (t) { return (_this.inferredTypes[t] || t); }));
                    return this._typeResolver(type).finalType;
                }
                else {
                    return this._typeResolver(this.type).finalType;
                }
            }
            return this.type;
        },
        enumerable: false,
        configurable: true
    });
    return Library;
}(ScryptType));
exports.Library = Library;
var HashedMap = /** @class */ (function (_super) {
    __extends(HashedMap, _super);
    function HashedMap(data) {
        var _this = _super.call(this, data) || this;
        _this.setProperties({
            '_data': data
        });
        _this._typeResolver = function (t) { return ({ finalType: t, symbolType: SymbolType.Library }); }; //we should assign this before bind
        _this.bind();
        return _this;
    }
    return HashedMap;
}(Library));
exports.HashedMap = HashedMap;
HashedMap.libraryAst = {
    name: 'HashedMap',
    params: [
        {
            name: '_data',
            type: 'bytes'
        }
    ],
    properties: [
        {
            name: '_data',
            type: 'bytes'
        }
    ],
    genericTypes: ['K', 'V']
};
var HashedSet = /** @class */ (function (_super) {
    __extends(HashedSet, _super);
    function HashedSet(data) {
        var _this = _super.call(this, data) || this;
        _this.setProperties({
            '_data': data
        });
        _this._typeResolver = function (t) { return ({ finalType: t, symbolType: SymbolType.Library }); }; //we should assign this before bind
        _this.bind();
        return _this;
    }
    return HashedSet;
}(Library));
exports.HashedSet = HashedSet;
HashedSet.libraryAst = {
    name: 'HashedSet',
    params: [
        {
            name: '_data',
            type: 'bytes'
        }
    ],
    properties: [
        {
            name: '_data',
            type: 'bytes'
        }
    ],
    genericTypes: ['E']
};
var SortedItem = /** @class */ (function (_super) {
    __extends(SortedItem, _super);
    function SortedItem(data) {
        var _this = _super.call(this, data) || this;
        _this._typeResolver = function (t) { return ({ finalType: t, symbolType: SymbolType.Struct }); }; //we should assign this before bind
        _this.bind();
        return _this;
    }
    return SortedItem;
}(Struct));
exports.SortedItem = SortedItem;
SortedItem.structAst = {
    name: 'SortedItem',
    params: [
        {
            name: 'item',
            type: 'T'
        },
        {
            name: 'idx',
            type: 'int'
        }
    ],
    genericTypes: ['T']
};
var VariableType;
(function (VariableType) {
    VariableType["BOOL"] = "bool";
    VariableType["INT"] = "int";
    VariableType["BYTES"] = "bytes";
    VariableType["PUBKEY"] = "PubKey";
    VariableType["PRIVKEY"] = "PrivKey";
    VariableType["SIG"] = "Sig";
    VariableType["RIPEMD160"] = "Ripemd160";
    VariableType["SHA1"] = "Sha1";
    VariableType["SHA256"] = "Sha256";
    VariableType["SIGHASHTYPE"] = "SigHashType";
    VariableType["SIGHASHPREIMAGE"] = "SigHashPreimage";
    VariableType["OPCODETYPE"] = "OpCodeType";
    VariableType["PUBKEYHASH"] = "PubKeyHash";
    VariableType["STRUCT"] = "struct";
    VariableType["LIBRARY"] = "library";
})(VariableType = exports.VariableType || (exports.VariableType = {}));
exports.BasicType = Object.keys(VariableType).map(function (key) { return VariableType[key]; });
exports.BasicScryptType = (_a = {},
    _a[VariableType.BOOL] = Bool,
    _a[VariableType.INT] = Int,
    _a[VariableType.BYTES] = Bytes,
    _a[VariableType.PUBKEY] = PubKey,
    _a[VariableType.PRIVKEY] = PrivKey,
    _a[VariableType.SIG] = Sig,
    _a[VariableType.RIPEMD160] = Ripemd160,
    _a[VariableType.SHA1] = Sha1,
    _a[VariableType.SHA256] = Sha256,
    _a[VariableType.SIGHASHTYPE] = SigHashType,
    _a[VariableType.OPCODETYPE] = OpCodeType,
    _a[VariableType.SIGHASHPREIMAGE] = SigHashPreimage,
    _a);
function serializeSupportedParamType(x) {
    if (typeof x === 'boolean') {
        return new Bool(x).serialize();
    }
    else if (typeof x === 'number' || typeof x === 'bigint') {
        return serializer_1.serialize(x);
    }
    else if (x instanceof ScryptType) {
        return x.serialize();
    }
    else {
        throw new Error('serializeSupportedParamType unsupported: ' + x);
    }
}
exports.serializeSupportedParamType = serializeSupportedParamType;
//# sourceMappingURL=scryptTypes.js.map